import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import "./polyfills";
import { initMetaPixel } from "./utils/metaPixel";
import { persistReferralAddressFromEntry } from "./utils/referral";
import { persistAdsgramTrackingFromEntry } from "./utils/adsgram";

// Entry params are saved first: initMetaPixel removes them from the URL so Meta never receives them.
persistReferralAddressFromEntry();
persistAdsgramTrackingFromEntry();
initMetaPixel();

const manifestUrl =
    "https://cryptolotto777.com/tonconnect-manifest.json";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <TonConnectUIProvider manifestUrl={manifestUrl}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </TonConnectUIProvider>
);

reportWebVitals();